// The Share door — the counter pill's register (`Counter.module.scss`'s `counter-surface`): a small
// surfaced round glyph in the frame's top-right corner, tokens only. z-index 5 clears the counter's
// zones and pill (3-4) inside the sheet's picture.
.door {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 5;
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    appearance: none;
    cursor: pointer;
    color: var(--tl-muted);
    background: color-mix(in srgb, var(--tl-surface) 92%, transparent);
    border: 1px solid var(--tl-border);
    border-radius: var(--tl-radius-pill);

    svg {
        display: block;
    }

    &:hover,
    &[aria-expanded='true'] {
        color: var(--tl-text);
    }

    &:focus-visible {
        outline: 1px solid var(--tl-accent);
        outline-offset: 2px;
    }

    // A finger gets the reach the counter's door gives it.
    @media (pointer: coarse) {
        width: 44px;
        height: 44px;
    }
}

.menu {
    display: flex;
    flex-direction: column;
    min-width: 168px;
    padding: 4px;
    background: var(--tl-surface);
    border: 1px solid var(--tl-border-strong);
    border-radius: var(--tl-radius-chrome);
    box-shadow: 0 12px 32px color-mix(in srgb, var(--tl-shadow-ink) 50%, transparent);
}

// The column: under the glyph, on the frame.
.float {
    position: absolute;
    top: 46px;
    right: 8px;
    z-index: 6;
}

// The sheet: in the flow above the bar, like the ratio row — the frame clips what opens inside it.
.flow {
    align-self: stretch;
    margin: 0 0 8px;
}

.item {
    appearance: none;
    background: none;
    border: none;
    text-align: left;
    padding: 10px 12px;
    font-family: var(--tl-font);
    font-size: 13.5px;
    color: var(--tl-text);
    border-radius: var(--tl-radius-art-lg);
    cursor: pointer;

    &:hover,
    &:focus-visible {
        background: color-mix(in srgb, var(--tl-accent) 10%, transparent);
        outline: none;
    }
}
